export const SET_TOKENS = "SET_TOKENS"
export const GET_TOKEN = "GET_TOKEN"
export const DELETE_TOKENS = "DELETE_TOKENS"